var map = {
	"./1.png": "0ca1",
	"./1hover.png": "4eee",
	"./22.png": "2a2b",
	"./22hover.png": "bd93",
	"./3.png": "c2e4",
	"./3hover.png": "3e80",
	"./4.png": "1105",
	"./4hover.png": "71dd",
	"./Android_btn.png": "7488",
	"./GAT/App_store.png": "fe18",
	"./GAT/BG2.png": "d685",
	"./GAT/BG2_title.png": "0fc6",
	"./GAT/BG3-1.png": "04b7",
	"./GAT/BG_1.png": "7cb7",
	"./GAT/Google_play.png": "cc5a",
	"./GAT/LB1.png": "525c",
	"./GAT/LB2.png": "7694",
	"./GAT/LB3.png": "4b36",
	"./GAT/L_road.png": "685a",
	"./GAT/R_road.png": "ddc4",
	"./GAT/SCROLL.png": "20e8",
	"./GAT/bg_center.png": "3381",
	"./GAT/checkN.png": "5c5c",
	"./GAT/close.png": "2c82",
	"./GAT/event3.png": "2612",
	"./GAT/event3_B.png": "d538",
	"./GAT/event3_bottom.png": "abfb",
	"./GAT/event4.png": "70d3",
	"./GAT/event5.png": "9351",
	"./GAT/events3.png": "a601",
	"./GAT/events4.png": "1cde",
	"./GAT/events5.png": "0491",
	"./GAT/facebook.png": "5124",
	"./GAT/fuchaun1.png": "eeae",
	"./GAT/fuchaung2.png": "a7f6",
	"./GAT/fuchuang2.png": "ca03",
	"./GAT/fuchuang3.png": "7395",
	"./GAT/fuzhuang.png": "49e5",
	"./GAT/fuzhuang1.png": "ba23",
	"./GAT/fuzhuang3.png": "9bd7",
	"./GAT/fuzhuang4.png": "bd05",
	"./GAT/greyBG.png": "39d2",
	"./GAT/ju_bottom.png": "47bc",
	"./GAT/loginPay.png": "3d10",
	"./GAT/logo_bottom.png": "3c30",
	"./GAT/mycard.png": "965b",
	"./GAT/shareicon.png": "6901",
	"./GAT/yu_btn.png": "e0a7",
	"./GAT/yubottom1.png": "94d8",
	"./GAT/yubottom2.png": "f27b",
	"./GAT/yubottom3.png": "83fc",
	"./GAT/yuyue.png": "c47a",
	"./GAT/yuyue_button.png": "e3bd",
	"./GAT/yuyue_top.png": "c6be",
	"./GAT/yuyue_top2.png": "b4fa",
	"./Google.png": "01b9",
	"./IOS_btn.png": "5de4",
	"./L_btn.png": "05a6",
	"./R_btn.png": "8508",
	"./X_BTN.png": "c983",
	"./a_share.png": "82cb",
	"./act.png": "d944",
	"./app0.png": "afb8",
	"./app1.png": "ee61",
	"./app2.png": "a723",
	"./app3.png": "fa82",
	"./app4.png": "a60e",
	"./arrowLeft.png": "e636",
	"./arrowRight.png": "386e",
	"./b1.png": "3204",
	"./b2.png": "fb18",
	"./b3.png": "e535",
	"./bg2.png": "028e",
	"./bgA.png": "5049",
	"./bgB.png": "dd68",
	"./bgC.png": "7e9c",
	"./bgD.png": "3761",
	"./bgbox.png": "8c08",
	"./booking.png": "bcc7",
	"./booking_btn.png": "1e67",
	"./booking_btn_hover.png": "752f",
	"./bottom_bar.png": "9f2d",
	"./box.png": "5636",
	"./box1.png": "f67b",
	"./box2.png": "2ce6",
	"./box3.png": "309f",
	"./box_bg.png": "f215",
	"./box_white.png": "d35a",
	"./boxbg.png": "4cbf",
	"./btn1.png": "6879",
	"./btn2.png": "9e76",
	"./btn3.png": "8c5b",
	"./btn4.png": "4356",
	"./button1.png": "8974",
	"./button2.png": "59bd",
	"./button3.png": "7aae",
	"./button_last.png": "3ecc",
	"./cacao_btn.png": "53ca",
	"./cafe.png": "066a",
	"./cafeHover.png": "0372",
	"./card_bg.png": "81a8",
	"./check.png": "f0c8",
	"./checked.png": "0993",
	"./circle.png": "088b",
	"./close1.png": "0a4d",
	"./closeBtn.png": "3fb6",
	"./close_share.png": "9c2e",
	"./copyright.png": "46fa",
	"./current.png": "81af",
	"./default.png": "113c",
	"./e1.png": "485c",
	"./face_btn.png": "92b0",
	"./facebook.png": "5307",
	"./facebookHover.png": "01cd",
	"./form_submit.png": "e7d6",
	"./frame.png": "e33d",
	"./gift2.png": "26ec",
	"./gift_icon.png": "9a04",
	"./iconPhone.png": "9547",
	"./img_left.png": "909f",
	"./info.png": "9417",
	"./info1.png": "ede9",
	"./infos.png": "a9ad",
	"./leftBtn.png": "b9cf",
	"./line.png": "aa06",
	"./lms.png": "db3c",
	"./logo.png": "cf05",
	"./logo_url.png": "a4ee",
	"./main_1.png": "74f3",
	"./main_2.png": "94be",
	"./menuBar.png": "055c",
	"./menu_btn.png": "9ad9",
	"./menu_on.png": "2064",
	"./next.png": "2952",
	"./next2.png": "5e66",
	"./night.png": "9b7a",
	"./notice.png": "818f",
	"./off.png": "6766",
	"./oneStore.png": "b222",
	"./onesto.png": "b889",
	"./p1.png": "f6c2",
	"./p2.png": "84e7",
	"./p3.png": "7dc7",
	"./p4.png": "bae0",
	"./p5.png": "08a0",
	"./play_btn.png": "5e75",
	"./puzzle_1.png": "c992",
	"./puzzle_2.png": "f2ba",
	"./puzzle_3.png": "16ba",
	"./puzzle_4.png": "acf9",
	"./puzzle_5.png": "cc5d",
	"./puzzle_6.png": "a0f4",
	"./puzzle_7.png": "f8e5",
	"./puzzle_8.png": "1dab",
	"./puzzle_9.png": "64c1",
	"./question.png": "61e2",
	"./radio.png": "51bd",
	"./radioSelected.png": "de2e",
	"./rightBtn.png": "1585",
	"./samsun.png": "d67b",
	"./scroll.png": "cf65",
	"./scrollUp.png": "a6b0",
	"./share.png": "75e1",
	"./shareBg1.png": "b6c4",
	"./shareHover.png": "e170",
	"./share_bg.png": "6852",
	"./share_title.png": "f58c",
	"./success.png": "6582",
	"./swiper_1.png": "c321",
	"./swiper_2.png": "b3a6",
	"./swiper_3.png": "6b04",
	"./swiper_4.png": "5ece",
	"./swiper_5.png": "7c14",
	"./t.png": "c61c",
	"./talk.png": "2534",
	"./title_2.png": "ee31",
	"./title_2_active.png": "dfe5",
	"./title_3.png": "893e",
	"./title_3_active.png": "0250",
	"./title_4.png": "698d",
	"./title_4_active.png": "34bb",
	"./twitter.png": "e4d7",
	"./twitterHover.png": "81c8",
	"./video_btn.png": "99b9",
	"./z-stop.png": "2f63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";